import makePaginateReducer, {
  defaultState as paginationDefaultState,
} from './paginate'
import { endsWith, omit, without } from 'lodash'
import {
  GET_SWAPS,
  SWAP_ACTION_HIDE_SUCCESS,
  GET_SWAPS_UNLOAD,
} from '../actions'
import { isSwapAction } from './helpers'

const paginationReducer = makePaginateReducer(GET_SWAPS)

const defaultState = {
  ...paginationDefaultState,
  // Performing swap action ...
  performingActionById: {},
}

const performingActionReducer = (prevState, action) => {
  if (endsWith(action.type, 'LOADING')) {
    return {
      ...prevState,
      [action.payload.swapId]: true,
    }
  } else if (
    endsWith(action.type, 'SUCCESS') || endsWith(action.type, 'FAILURE')
  ) {
    return {
      ...prevState,
      [action.payload.swapId]: false,
    }
  }
  return prevState
}

const swapsReducer = (prevState, { type, payload }) => {
  switch (type) {
    case SWAP_ACTION_HIDE_SUCCESS:
      return {
        ...prevState,
        data: omit(prevState.data, payload.swapId),
        ids: without(prevState.ids, payload.swapId),
      }
    default:
      return prevState
  }
}

export default (prevState = defaultState, action) => {
  const partialNewState = swapsReducer(
    paginationReducer(prevState, action),
    action
  )

  if (isSwapAction(action)) {
    return {
      ...partialNewState,
      performingActionById: performingActionReducer(
        prevState.performingActionById,
        action
      ),
    }
  }

  if (action.type === GET_SWAPS_UNLOAD) {
    return defaultState
  }

  return partialNewState
}



// WEBPACK FOOTER //
// ./src/reducers/swaps.js